<template>
	<v-dialog slot="activator" v-model="dialog" persistent max-width="300px">
		<v-btn slot="activator" icon >
			<v-icon color="grey darken-2">{{this.icon}}</v-icon>
		</v-btn>
		<v-card>
			<v-toolbar>
				<v-toolbar-title>
					{{ this.icon == "edit" ?  'EDIT FLOOR' : 'ADD NEW FLOOR ' }}
				</v-toolbar-title>
			</v-toolbar>
			<v-card-title class="body-2" color="black">
				<v-layout column class="pl-1 pt-2"> 
				</v-layout>
			</v-card-title>
			<v-card-text class="pb-5">
				<v-form v-if="floor" v-model="valid" ref="form">
					<v-layout column class="mb-2 pl-4 pr-2">
						<v-flex xs3 class="mb-2 pr-4">
							<v-text-field
								class="body-1"
								outline
								hide-details
								v-model="floor.floorNumber"
								@input="changed = true"
								label="Number">
							</v-text-field>
						</v-flex>
						<v-flex xs3 class="mb-2 pr-4">
							<v-text-field
								class="body-1"
								outline
								hide-details
								v-model="floor.grossArea"
								@input="changed = true"
								label="Area">
							</v-text-field>
						</v-flex>						
						<v-checkbox
							v-model="floor.areaType"
							true-value="CAD"
							false-value="MAN"
							label="Use CAD Area For Rooms"
							class="mb-0"
						></v-checkbox>
						<v-checkbox
							v-model="floor.restricted"
							true-value="Y"
							label="Restricted"
							class="mt-0"
						></v-checkbox>
						
						
						<span class="body-2 mt-3">{{ this.floor.drawings.length > 1 ?  'Drawings' : 'Drawing' }}</span>

						<div v-for="(item, index) in floor.drawings" :key="index" >	
						    		<v-layout 
						    			row fill-height align-center>
						        		<v-flex xs6>
						        			<v-text-field
						        			v-model="item.drawing"
						        				:label="item.drawing ? '' : 'Drawing'"
									            autofocus
									            @change="changed = true"
									            :rules="drawingRules">
									        </v-text-field>
			      						</v-flex>
						        		
				    					<v-flex xs1 class='mr-4 mt-3'>
				    						<v-tooltip top>
					    						<v-btn slot="activator" icon @click="deleteDrawing(index)"><v-icon  color="red lighten-2">close</v-icon></v-btn>
					    						<span>Remove</span>
				    						</v-tooltip>
				    					</v-flex>
						        	</v-layout>
						        	
						        </div>	
						        
						        <v-btn ref="addRowBtn" class="ml-1 mt-3" icon small @click="addDrawing" color="grey lighten-2"><v-icon>add</v-icon></v-btn>


					</v-layout>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" flat @click.native="dialog=false">
					Cancel
				</v-btn>
				<v-btn color="green darken-1" flat @click.native="save">
					{{this.newFlr ? 'Add' : 'Save'}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
	name: "EditFloorDialog",

	data() {
		return {
			valid: false,
			dialog: false,
			floor: null,
			newFloor: { areaType: 'CAD'},
			drawingRules: [v => !!v || "Field is required", v => !v || (v || '').length <= 50 || "50 characters maximum"]
		}
	},

	props: [ 'icon', 'newFlr' ],

	watch: {
		
		dialog (val) { 
			// If prop is for newFloor use the newFloor object.  Otherwise, use dvFloor
			if (this.newFlr) { 	this.resetNewFloor()  		} 
			else { 				this.floor = this.dvFloor  	}
		}

	},

	computed: {
		...mapState({		dvSelectedBuilding: state => state.dv.building,
							dvFloor: state => state.dv.floor,
		})
	},

	methods: {
		...mapMutations([	'setSnackText', 'setdvBuilding', 'setdvFloor'		]),
		...mapActions([		'saveFloor', 'fetchBuilding', 'fetchFloor', 'fetchBuildings'			]),

		save: function() {
			 
			// Validate Form 
			if (!this.valid) { this.setSnackText("Form has validation errors");	return;	}

			// Fix default
			if (!this.floor.areaType ) { this.floor.areaType="MAN" }

			// Update floor local memory and database
			this.setdvFloor(this.floor)	
			console.log(this.floor)
			this.saveFloor({ floor: this.floor }).then((response) => {
				if (response != "Saved") { this.setSnackText(response) }
			})

			// Fetch API version of floor and save that to local var.
			this.fetchFloor({bldgAlpha: this.dvSelectedBuilding.bldgAlpha, floor: this.floor.floorNumber })
			.then((data)=> { this.setdvFloor(data) })
			
			// Update the Building Detail showing on the screen
			this.fetchBuilding(this.dvSelectedBuilding.bldgAlpha).then((data) => {				
				this.setdvBuilding(data)				
			})

			//refresh local buildings data
			this.fetchBuildings()

			this.dialog=false
			
		},

		addDrawing() {
			this.floor.drawings.push({drawing:null, ID: null})
		},
		deleteDrawing(index) {
			this.floor.drawings.splice(index,1)
		},

		resetNewFloor: function() {
			this.floor = { ...this.newFloor }; // object copy
			this.floor.drawings = [{drawing: null, ID: null}]
			this.floor.floorNumber = (parseInt(this.dvSelectedBuilding.floors[this.dvSelectedBuilding.floors.length-1]) + 1 ) || '1'
			this.floor.bldgNumber = this.dvSelectedBuilding.bldgNumber
		}
	}
}

</script>

<style></style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/EditFloorDialog.vue